exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-toast-width{width:225px!important;font-size:12px}", ""]);

// exports
